import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions/calc-rem'
import { themedValue } from 'component-library/__styling/themed-value'
import { colors, easing } from 'component-library/__styling/settings'
import { withClass } from 'common/emotion'
import { visuallyhidden } from 'component-library/__styling/style-mixins'

interface StyledActiveProps {
    active?: boolean
}

const StyledToggleSwitchClassName = 'StyledToggleSwitch'

export const StyledToggleCheckbox = styled('input')(visuallyhidden)
export const StyledToggleLabel = styled('label')(visuallyhidden)

export const StyledToggle = styled('div')({
    margin: calcRem(10, 0, 20),
    height: calcRem(30),
})

export const StyledToggleButton = styled('button')({
    background: 'transparent',
    border: 0,
    cursor: 'pointer',
    padding: 0,
})

export const StyledToggleSwitch = withClass(StyledToggleSwitchClassName)(
    styled('div')({
        position: 'absolute',
        top: 0,
        margin: calcRem(3),
        width: calcRem(24),
        height: calcRem(24),
        borderRadius: calcRem(26),
        background: colors.white,
        transition: `left ${easing.easeOut.fast}, transform ${easing.easeOut.fast}, margin ${easing.easeOut.fast}`,
    })
)

export const StyledToggleBackground = styled('div')<StyledActiveProps>(
    {
        position: 'relative',
        overflow: 'hidden',
        width: calcRem(55),
        height: calcRem(30),
        borderRadius: calcRem(50),
        label: 'StyledToggleBackground',
        transition: `background-color ${easing.easeOut.fast}`,
    },
    props => ({
        background: themedValue(props.theme, {
            thewest: section => (props.active ? section.primaryColor : colors.thewest.greyDolphin),
            sevennews: props.active ? colors.sevennews.red : colors.thewest.greyDolphin,
            perthnow: props.active ? colors.perthnow.pinkThulite : colors.thewest.greyDolphin,
            fallback: props.active ? colors.thewest.westblue : colors.thewest.greyDolphin,
        }),

        [`.${StyledToggleSwitchClassName}`]: {
            transform: props.active ? 'translateX(100%)' : 'translateX(0)',
        },
    })
)
